module.exports = __webpack_public_path__ + "img/e_3_19_g.3be56850.png";